import { Surreal, Tokens } from "surrealdb";
import { create } from "zustand";

import { connect, signin, signup } from "../services/connection";

export type LocalRef = string;

export const useConnection = create<{
  connection: Surreal;
  connect: () => Promise<Surreal>;
  signup: (code: string) => Promise<Tokens>;
  signin: (code: string, access: "admin" | "user") => Promise<Tokens>;
}>((_set, get) => {
  return {
    connection: new Surreal(),
    connect: async () => {
      const connection = get().connection;
      if (!connection.isConnected) {
        await connect(connection);
      }

      return connection;
    },
    signup: async (code: string) =>
      signup({ connection: await get().connect(), code }),
    signin: async (code: string, access: "admin" | "user") =>
      signin({ connection: await get().connect(), code, access }),
  };
});
